import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { CorporateTheme, font } from "../../utils/themes";
import StyledText from "../../components/StyledComponents/StyledText";
import { Form, Formik } from "formik";
import { Button } from "../../components/form/Button";
import CrossIcon from "../../assets/icons/CrossIcon";
import LoadingCircleIcon from "../../assets/icons/LoadingCircleIcon";
import * as Yup from "yup";
import { useToast } from "../../components/toast/ToastContext";
import FormikSelect from "../../components/Formik/FormikSelect";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getQueryDescription,
  getQueryFolderId,
  getQueryFolders,
  getQueryName,
  getQueryScope,
  setQueryDescription,
  setQueryFolderId,
  setQueryName,
  setQueryScope,
} from "./QuerySlice";
import { useNavigate } from "react-router-dom";
import DocumentIcon from "../../assets/icons/document-text";
import FormikInputField from "../../components/Formik/FormikInputField";
import { useTheme } from "../../middleware/ThemeContext";
import { useGetScopesforFieldsQuery } from "../../api/formsApiSlice";
import { Scope } from "../../types/types";
import { useGetQueryFoldersQuery, useSaveQueryMutation } from "../../api/searchQueryApiSlice";
import { LoadingSpinner } from "../ui/LoadingSpinner";
import SaveIcon from "../../assets/icons/SaveIcon";
import ModalHeaderBg from "../../assets/images/CreateFormBackground.png";
interface QueryScopeModalProps {
  onClose: () => void;
  title?: string;
  subTitle?: string;
  edit?: boolean; // Added edit prop to determine if it's in edit mode
  setSelectedColumns: React.Dispatch<React.SetStateAction<any[]>>;
  setTableData?: React.Dispatch<React.SetStateAction<any[]>>
  id?: string;
  // refetch?: any;
  // setColumnsState?: (columns: any[]) => void;
  data?: any
}

const QueryScopeModal: React.FC<QueryScopeModalProps> = ({
  onClose,
  title,
  subTitle,
  id,
  edit,
  // refetch,
  setSelectedColumns,
  // setColumnsState,
  setTableData,
  data
}) => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const queryFolders = useSelector(getQueryFolders);
  const showToast = useToast();
  const { data: scopesData = [], isLoading: scopesLoading } = useGetScopesforFieldsQuery({ isVisible: true });
  const [saveNewQuery, { isLoading: saveQueryLoading }] =
    useSaveQueryMutation();

  const [selectedScope, setSelectedScope] = useState<string>(
    edit ? data?.scope ?? "" : ""
  );
  const ScopeInitialValues = {
    scope: edit ? data?.scope : "",
    name: edit ? data?.name : "",
    folderId: edit ? data?.folderId : undefined,
    description: edit ? data?.description : undefined,
  };

  interface TransformedOption {
    label: string;
    value: number | string;
  }

  const transformedOptions: TransformedOption[] = [];

  queryFolders &&
    queryFolders?.forEach((parent: any) => {
      if (["PUBLIC", "PRIVATE"].includes(parent.name)) {
        transformedOptions.push({
          label: parent.name,
          value: parent.id,
        });

        parent.children?.forEach((child: any) => {
          transformedOptions.push({
            label: `${parent.name} > ${child.name}`,
            value: child.id,
          });

          child?.grandChildren?.forEach((grandChild: any) => {
            transformedOptions.push({
              label: `${parent.name} > ${child.name} > ${grandChild.name}`,
              value: grandChild.id,
            });
          });
        });
      }
    });

  const setScopeSchema = Yup.object().shape({
    scope: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    folderId: Yup.string().required("Required"),
  });

  const handleSubmit = async (value: typeof ScopeInitialValues) => {

    const call = saveNewQuery;
    const val = {
      name: value?.name,
      parentFolderId: value?.folderId,
      scope: value?.scope,
      description: value?.description,
    };

    let payload = edit ? { id: id, ...val } : val;
    try {
      const res = await call(payload).unwrap();

      if (res?.error) {
        showToast("Action Failed", `Failed to add query`, "error");
        return false;
      }

      if (res) {
        showToast(
          "Success",
          `Query Saved successfully`,
          "success"
        );

        if (!edit) {
          setSelectedColumns([]);
          setTableData?.([]);
        }

        navigate(`/home/search-query/query-preview/${res?.id}`, { state: { item: res } });
        onClose();
        return res?.id;
      }
    } catch (err) {
      showToast("Error", "Failed to save query", "error");
      return false;
    }

  };

  return (
    <Modal show={true} onHide={onClose} size="lg" centered>
      <StyledModalContent theme={theme}>
        <ModalHeader>
          <ModalCloseButton theme={theme} onClick={onClose}>×</ModalCloseButton>
          <ModalTitle>
            <TitleText theme={theme}>{title ?? "Query Scope"}</TitleText>
            <StyledText
              fontSize="14px"
              fontWeight={500}
              textColor={theme?.CorporateTheme?.colors?.textSecondary}
            >
              {subTitle ??
                "Choose a query scope to create a query within that scope."}
            </StyledText>
          </ModalTitle>
        </ModalHeader>
        <Formik
          initialValues={ScopeInitialValues}
          enableReinitialize
          validationSchema={setScopeSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, setFieldValue, values, touched, errors }) => (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <div className="d-flex align-items-center  px-4 py-3 mx-5 rounded" style={{ border: `1px solid ${theme?.CorporateTheme?.colors?.border}` }}>
                  {/* <div className="d-flex  flex-column rounded-md dark:border-textColor bg-white rounded  overflow-y-auto"> */}
                  <div className="p-4 w-100">
                    <div className="mb-3">
                      <StyledText
                        className=" mb-2"
                        textColor={theme?.CorporateTheme?.colors?.headerColor}
                      >
                        Name <span className="text-danger ">*</span>
                      </StyledText>
                      <FormikInputField
                        name="name"
                        placeholder="Enter Query Name"
                        onChange={(e) => {
                          setFieldValue("name", e.target.value);
                        }}
                      />
                    </div>

                    <div className="mt-3">
                      <StyledText
                        className=" mb-2"
                        textColor={theme?.CorporateTheme?.colors?.headerColor}
                      >
                        Select Scope <span className="text-danger ">*</span>
                      </StyledText>{" "}
                      <FormikSelect
                        className={id && "class-disable"}
                        options={scopesData?.scopes?.map((scope: Scope) => ({
                          value: scope.name,
                          label: scope.displayName,
                        })) || []}
                        name="scope"
                        placeholder="Select Query Scope"
                        onChange={(
                          val:
                            | string
                            | { label: string; value: number | string }
                        ) => {
                          const value =
                            typeof val === "string" ? val : val.value;
                          setFieldValue("scope", value);
                          setSelectedScope(String(value));

                        }}
                        disabled={id ? true : false}
                      />
                    </div>

                    {selectedScope && (
                      <div
                        className="mt-4"
                        style={{
                          backgroundColor: theme?.CorporateTheme?.colors?.bannerBg,
                          padding: "10px",
                          borderRadius: "4px",
                        }}
                      >
                        <StyledText
                          className=" mb-2"
                          fontSize="14px"
                          fontWeight={600}
                          textColor={theme?.CorporateTheme?.colors?.headerColor}
                        >
                          About this Query Type
                        </StyledText>
                        <StyledText
                          className=" mb-2"
                          fontSize="11px"
                          fontWeight={400}
                          textColor={theme?.CorporateTheme?.colors?.textSecondary}
                        >
                          {data?.scope === "contact"
                            ? `Search across individual contacts and their roles
                          within organizations. Ideal when you're looking for
                          people-specific information.`
                            : data?.scope === "CRM"
                              ? "Search for company-level information, including names, websites, domains, and locations. Focused on businesses, not individuals."
                              : "Search across everything — contacts, their roles, and organizations. Best for a complete view of your CRM data."}
                        </StyledText>
                      </div>
                    )}

                    <div className="mt-3">
                      <StyledText
                        className=" mb-2"
                        textColor={theme?.CorporateTheme?.colors?.headerColor}
                      >
                        Select Folder <span className="text-danger ">*</span>
                      </StyledText>{" "}
                      <FormikSelect
                        options={transformedOptions}
                        name="folderId"
                        placeholder="Select Folder"
                        value={
                          transformedOptions.find(
                            (opt) => opt.value === values.folderId
                          ) || null
                        }
                        onChange={(
                          val:
                            | string
                            | { label: string; value: string | number }
                        ) => {
                          const value =
                            typeof val === "string" ? val : val.value;
                          setFieldValue("folderId", value);
                        }}
                      />
                    </div>

                    <div className="mt-3">
                      <StyledText
                        className=" mb-2"
                        textColor={theme?.CorporateTheme?.colors?.headerColor}
                      >
                        Description
                      </StyledText>
                      <FormikInputField
                        rows={3}
                        as="textarea"
                        name="description"
                        placeholder="Enter description here"
                        onChange={(e) => {
                          setFieldValue("description", e.target.value);

                        }}
                      />
                    </div>
                  </div>

                </div>
                <div className="d-flex align-items-center justify-content-end mt-3 me-5">
                  <div className="d-flex gap-1">
                    <Button
                      theme={theme}
                      type="button"
                      className={`cursor-pointer ${""
                        }`}
                      $variant="cancel"
                      onClick={onClose}
                    >
                      <CrossIcon color={theme?.CorporateTheme?.colors?.headerColor}/>
                      Cancel
                    </Button>
                    <Button
                      theme={theme}
                      type="submit"
                      $variant="add"
                      className="cursor-ponter"
                    >

                      {saveQueryLoading ? <LoadingSpinner color={theme.CorporateTheme.colors.background} size="20px" /> : <SaveIcon color={theme.CorporateTheme.colors.background} />} {edit ? "Update" : "Save"}

                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Form>
          )}
        </Formik>

        <ModalFooter></ModalFooter>
      </StyledModalContent>
    </Modal>
  );
};

export default QueryScopeModal;

export const StyledModalContent = styled('div')(({ theme }) => ({
  borderRadius: '5px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  background: theme?.CorporateTheme?.colors?.background,
}));

export const ModalHeader = styled.div`
  position: relative;
  padding-bottom: 30px;
  background-image: url(${ModalHeaderBg});
  background-size: cover;
   background-position: center 16%;
  background-size: 80% auto;
`;

export const ModalTitle = styled.div`
  text-align: center;
  padding: 0 30px;
  margin-top: 30px;
`;

export const ModalBody = styled.div`
  padding-top: 0;
`;

export const ModalCloseButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  top: '-26px',
  right: '7px',
  background: 'none',
  border: 'none',
  fontSize: '32px',
  cursor: 'pointer',
  color: theme?.CorporateTheme?.colors?.textSecondary,
  width: '30px',
  height: '30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',

  // '&:hover': {
  //   color: '#333',
  //   padding: '0px',
  // },
}));

export const TitleText = styled('div')(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 600,
  color: theme?.CorporateTheme?.colors?.primary,
  fontFamily: font.raleway,
}));

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  // padding-top: 20px;
  padding: 30px;
`;
